import { MutationHookOptions, TypedDocumentNode, gql } from "@apollo/client";

import {
  AssignAlertMutation,
  AssignAlertMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { searchAlertsQuery } from "src/graphql/anti-fraud/queries/alerts/SearchAlertsQuery.ts";
import { usePerformMutation } from "src/graphql/utils";

const assignAlertMutation = gql(/* GraphQL */ `
  mutation assignAlert($id: ID!, $userId: String) {
    assignAlert(id: $id, options: { userId: $userId }) {
      ...AlertFragment
    }
  }
`) as TypedDocumentNode<AssignAlertMutation, AssignAlertMutationVariables>;

export const useAssignAlertMutation = ({
  mutationOption,
  onSuccess,
}: {
  onSuccess?: () => void;
  mutationOption?: MutationHookOptions<AssignAlertMutation, AssignAlertMutationVariables>;
} = {}) => {
  return usePerformMutation(assignAlertMutation, {
    onSuccess,
    mutationOption: {
      refetchQueries: [searchAlertsQuery],
      ...mutationOption,
    },
  });
};
